import React from "react";
import { useLocation, Link, Switch, Route } from "react-router-dom";

import { Title, Tab, Field, Control, Label, Input } from "rbx";

import moment from "moment";

import { useLocalStorage } from "../../../utils/hooks";

import { RouteVerified, BillingVerified, Cancelled } from "./routes";

const InvoiceProcessingPage = () => {
  const location = useLocation();
  const [date, setDate] = useLocalStorage(
    "SELECT_FOR_BILLING_DATE",
    moment().format("YYYY-MM-DD")
  );

  return (
    <div>
      <header className="page-head">
        <div className="page-head-start">
          <div>
            <Title subtitle>Select For Billing</Title>
            <Title>{`Through ${moment(date).format("MMM DD, YYYY")}`}</Title>
          </div>
        </div>
        <div className="page-head-end">
          <Field kind="group">
            <Control>
              <Label>Delivery Date</Label>
              <Input
                type="date"
                value={date}
                onChange={({ target: { value } }) => setDate(value)}
              />
            </Control>
          </Field>
        </div>
      </header>
      <Tab.Group kind="boxed">
        <Tab
          active={new RegExp(/route-verified$/).test(location.pathname)}
          as={Link}
          tabIndex="-1"
          to="/finance/invoice-processing/route-verified"
        >
          <span>Route Verified</span>
        </Tab>

        {/* <Tab
          as={Link} tabIndex="-1"
          to="/finance/invoice-processing/no-bill"
          active={new RegExp(/no-bill$/).test(location.pathname)}
        >
          <span>No Bill</span>
        </Tab> */}
        <Tab
          active={new RegExp(/billing-verified$/).test(location.pathname)}
          as={Link}
          tabIndex="-1"
          to="/finance/invoice-processing/billing-verified"
        >
          <span>Billing Verified</span>
        </Tab>
        <Tab
          active={new RegExp(/cancelled$/).test(location.pathname)}
          as={Link}
          tabIndex="-1"
          to="/finance/invoice-processing/cancelled"
        >
          <span>Cancelled</span>
        </Tab>
      </Tab.Group>
      <Switch>
        <Route path="/finance/invoice-processing/route-verified">
          <RouteVerified date={date} />
        </Route>
        <Route path="/finance/invoice-processing/billing-verified">
          <BillingVerified date={date} />
        </Route>
        <Route path="/finance/invoice-processing/cancelled">
          <Cancelled date={date} />
        </Route>
        {/* <Route path="/finance/invoice-processing/no-bill">
          <NoBill />
        </Route> */}
      </Switch>
    </div>
  );
};
export default InvoiceProcessingPage;
